const navigationConfig = {
    // List of pages where navigation (header and side drawer) will not be rendered
    ignoredOnPages: ['login'],
};

export default navigationConfig;
